import dayjs from "dayjs";
import { Box, Card, Divider, Grid, Group, Popover, Stack, UnstyledButton } from "@mantine/core";
import Text from "@/components/atoms/Text";
import classes from "./styles.module.css";
import { useState } from "react";
import { OrderTimeSlot } from "@/types";
import { useAuth } from "@/contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { useGetOrderById } from "@/services/Orders";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";

export const EventCard = ({ event, compact = false }: { event: OrderTimeSlot; compact?: boolean }) => {
  const [opened, setOpened] = useState(false);
  const { user } = useAuth();
  const { t } = useTranslation();

  const { data: order } = useGetOrderById(event.orderId, undefined, undefined, {
    enabled: !!event.orderId,
  });

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
      withArrow
      arrowPosition="side"
      arrowSize={12}
      arrowOffset={15}
    >
      <Popover.Target>
        <UnstyledButton onClick={() => setOpened((o: boolean) => !o)} className={classes.button}>
          {event?.counterPartyName} -
          {event?.salesItem?.nameTranslated?.[user?.language?.id as number] ?? event.salesItem.salesItem ?? ""}
          {event?.amount}
        </UnstyledButton>
      </Popover.Target>

      <Popover.Dropdown classNames={{ dropdown: classes.dropdown, arrow: classes.arrow }} w={300}>
        <Card withBorder padding="lg" radius="md" className={classes.card}>
          <Grid p={0}>
            <Grid.Col span={11} p={0}>
              <Text
                className={classes.title}
              >{`${event.counterPartyName} - ${event.companySpecificproduct.companySpecificProductName} - ${event?.salesItem?.nameTranslated?.[user?.language?.id as number] ?? event.salesItem.salesItem ?? ""}`}</Text>
            </Grid.Col>
            <Grid.Col span={1} p={0}>
              <Group gap={5}>
                <SVGAsset name={event?.orderType?.type === "BUY" ? "purchaseIndicator" : "salesIndicator"} />
              </Group>
            </Grid.Col>
          </Grid>
          <Divider mt={12} />
          <Stack mt={"sm"} mb={"sm"} gap={3}>
            {event?.transportCompanyName && (
              <Group justify="space-between">
                <Text size="xs" c="dimmed">
                  {t("order:transportCompany")}
                </Text>
                <Text size="xs" c="dimmed">
                  {event?.transportCompanyName}
                </Text>
              </Group>
            )}

            <Group justify="space-between">
              <Text size="xs" c="dimmed">
                {event?.orderType?.type === "BUY" ? t("contracts:buyer") : t("contracts:seller")}
              </Text>
              <Text size="xs" c="dimmed">
                {event?.counterPartyName}
              </Text>
            </Group>

            <Group justify="space-between">
              <Text size="xs" c="dimmed">
                Dato
              </Text>
              <Text size="xs" c="dimmed">
                {dayjs(event?.startDate).format("DD.MM.YYYY")}
              </Text>
            </Group>

            <Group justify="space-between">
              <Text size="xs" c="dimmed">
                Tid
              </Text>
              <Text size="xs" c="dimmed">
                {dayjs(event?.startDate).format("HH:mm")} - {dayjs(event?.endDate).format("HH:mm")}
              </Text>
            </Group>
          </Stack>
          <Card.Section className={classes.footer}>
            <Box>
              <Text size="xs" c="dimmed">
                {t("common:amount")}
              </Text>
              <Text fw={500} size="sm">
                {order?.amount} {order?.unit.unit}
              </Text>
            </Box>
            <Box>
              <Text size="xs" c="dimmed">
                {t("product:material")}
              </Text>
              <Text fw={500} size="sm">
                {event.salesItem.nameTranslated[user?.language?.id as number] ?? event.salesItem.salesItem ?? ""}
              </Text>
            </Box>
            <Box>
              <Text size="xs" c="dimmed">
                {t("product:boxType")}
              </Text>
              <Text fw={500} size="sm">
                {t(`enumerables:boxTypes.${order?.packaging.boxtype.name ?? "undefined"}`)}
              </Text>
            </Box>
          </Card.Section>
        </Card>
      </Popover.Dropdown>
    </Popover>
  );
};

export default EventCard;
